import {
  classNamesFunction,
  IconButton,
  ITagItemStyleProps,
  ITagItemStyles,
  styled
} from "@bps/fluent-ui";

import { getMultiTagItemStyles } from "./MultiTagPickerItem.styles.ts";
import { MultiTagPickerItemProps } from "./MultiTagPickerItem.types.ts";

const getClassNames = classNamesFunction<ITagItemStyleProps, ITagItemStyles>();

/**
 * TagItem extracted from @fluentui/react
 * We need a way to prevent the TagItem from being focusable when used as a single picker
 * but the base component doesn't allow it.
 * Given it is a small component, it is ok to embed it.
 * @param props
 */
export const MultiTagPickerItemBase = (props: MultiTagPickerItemProps) => {
  const {
    theme,
    styles,
    selected,
    disabled,
    enableTagFocusInDisabledPicker,
    children,
    className,
    index,
    onRemoveItem,
    removeButtonAriaLabel,
    disableFocus,
    title = typeof props.children === "string"
      ? props.children
      : props.item.name
  } = props;

  const classNames = getClassNames(styles, {
    theme: theme!,
    className,
    selected,
    disabled
  });

  return (
    <div
      className={classNames.root}
      role="listitem"
      key={index}
      data-selection-index={index}
      data-is-focusable={
        (enableTagFocusInDisabledPicker || !disabled) && !disableFocus
      }
    >
      <span className={classNames.text} aria-label={title} title={title}>
        {children}
      </span>
      <IconButton
        data-is-focusable={disableFocus ? false : undefined}
        onClick={onRemoveItem}
        disabled={disabled}
        iconProps={{
          iconName: "Cancel",
          styles: { root: { fontSize: "12px" } }
        }}
        className={classNames.close}
        ariaLabel={removeButtonAriaLabel}
      />
    </div>
  );
};

export const MultiTagPickerItem = styled<
  MultiTagPickerItemProps,
  ITagItemStyleProps,
  ITagItemStyles
>(MultiTagPickerItemBase, getMultiTagItemStyles, undefined, {
  scope: "TagItem"
});
